export const commonKeyboardDatePickerProps = {
  OpenPickerButtonProps: {
    'aria-label': 'change date',
  },
  inputFormat: 'dd/MM/yyyy',
};
